module.exports = __webpack_public_path__ + "static/media/kadidelnice.cd003818.jpg";